/**
 * AWS Amplify Configuration for Cognito Authentication
 *
 * This file configures AWS Amplify to work with Cognito User Pools
 * and Google SSO (OAuth 2.0).
 *
 * IMPORTANT: This file must be imported early in the app lifecycle,
 * before any Amplify auth functions are called.
 */
import { Amplify } from 'aws-amplify';

// Get environment variables
const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;

// Only configure if Cognito is set up
if (userPoolId && clientId) {
  const authConfig = {
    Cognito: {
      userPoolId,
      userPoolClientId: clientId,
      signUpVerificationMethod: 'code',
    }
  };

  // Add OAuth config if domain is set (for Google SSO)
  if (cognitoDomain) {
    authConfig.Cognito.loginWith = {
      oauth: {
        domain: cognitoDomain,
        scopes: ['email', 'profile', 'openid'],
        redirectSignIn: [window.location.origin + '/auth/callback'],
        redirectSignOut: [window.location.origin + '/logout'],
        responseType: 'code',
      }
    };
  }

  // Configure Amplify - simple configuration without custom tokenProvider
  // The tokenProvider override was causing "Auth UserPool not configured" errors
  Amplify.configure({
    Auth: authConfig,
  });
}

export default Amplify;
